module.exports = __webpack_public_path__ + "static/p05_gallina-8fe27a9695fb5b0ae81b9221d5d608e8.png";